export default "__VITE_ASSET__13c176e0__"